// AUTO-GENERATED FILE - DO NOT EDIT DIRECTLY
// See generation source in nimble-components/build/generate-icons

import { trueFalseRectangle16X16 } from '@ni/nimble-tokens/dist/icons/js';
import { IconSvg, registerIconSvg } from '../../icon-svg';

declare global {
    interface HTMLElementTagNameMap {
        'nimble-icon-true-false-rectangle': IconTrueFalseRectangle;
    }
}

/**
 * The icon component for the 'trueFalseRectangle' icon
 */
export class IconTrueFalseRectangle extends IconSvg {
    public constructor() {
        super(trueFalseRectangle16X16);
    }
}

registerIconSvg('icon-true-false-rectangle', IconTrueFalseRectangle);
export const iconTrueFalseRectangleTag = 'nimble-icon-true-false-rectangle';
